export default __webpack_public_path__ + "static/media/blog-oil-stain-banner.04ee54dd.jpg";